/*
 *
 * Home reducer
 *
 */

import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import {
  processing,
  getHomeAssessmentsSuccess,
  getHomeNewsSuccess,
  getHomeBlogsSuccess,
  setGuideMeOpened,
} from './actions';

export const initialState = {
  assessments: {},
  processing: false,
  news: {},
  blogs: {},
  guideMeOpened: false,
};

const homeReducer = handleActions(
  {
    [processing](state, action) {
      return update(state, { processing: { $set: action.payload } });
    },
    [getHomeAssessmentsSuccess](state, action) {
      return update(state, { assessments: { $set: action.payload } });
    },
    [getHomeNewsSuccess](state, action) {
      return update(state, { news: { $set: action.payload } });
    },
    [getHomeBlogsSuccess](state, action) {
      return update(state, { blogs: { $set: action.payload } });
    },
    [setGuideMeOpened](state, action) {
      if (!action.payload) {
        sessionStorage.setItem('autopopup', false); // for variant D only
      }
      return update(state, { guideMeOpened: { $set: action.payload } });
    },
  },
  initialState,
);

export default homeReducer;
